import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';
import { UIComponentHandler, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { SearchListViewImpl } from './searchlistview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { SearchListCSSStyleImpl } from './searchlistcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { SearchListAPIModel, SearchListAPIModelImpl } from './searchlistapimodel';
import { SpecificSearchToneDto } from 'src/com/sixdee/crbtportal/core/dto/specificsearchtone/specificsearchtonedto';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
// import { AlertType } from '../../../toolkit/alert/alerttype';
import { SearchListToneViewModelImpl } from './searchlistviewmodel';
import { SearchListAtistToneViewModelImpl } from './artist/searchlistartistviewmodel';


export interface SearchListComponentProps extends CRBTUIComponentProps
{
    searchKey:string;
    type: string;
}


export interface SearchListComponentState extends UIComponentState
{
    isDataNotLoaded: boolean;
    isEmpty: boolean;
}

export interface SearchListComponentHandler extends UIComponentHandler
{
    onLoadMore(startIndex: number, offset: number): void;
    onDataNotLoaded(isNotLoaded: boolean): void;
    onSearchClicked(searchKey: string, type: string): void;
}

export class SearchListComponent extends CRBTUIComponent<SearchListComponentProps, SearchListComponentState> 
implements SearchListComponentHandler
{  
    private featuredCategoryListViewModel: SearchListToneViewModelImpl;
    private searchListAtistToneViewModelImpl: SearchListAtistToneViewModelImpl;
    private isOnLoadMore: boolean;

    constructor(props: SearchListComponentProps)
    {
        super(props);

        this.featuredCategoryListViewModel = new SearchListToneViewModelImpl(
            this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), props.context, "40px", 
        this.props.context.getResources().getString(Strings.search_results_for));

        this.searchListAtistToneViewModelImpl = new SearchListAtistToneViewModelImpl(
            this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"),props.context, "40px");

        this.featuredCategoryListViewModel.setListDatas([]);

        this.state = {isDataNotLoaded: false, isEmpty: true};
    }
   

    onDataNotLoaded(isNotLoaded: boolean): void {
      this.setState({isDataNotLoaded: isNotLoaded});
    }

    componentDidMount()
    {
        (this.getView() as SearchListViewImpl).showLoader(); 
        if(this.props.type === this.props.context.getResources().getString(Strings.code))
        {
            (this.getAPIModel() as SearchListAPIModel).getSearchToneBasedOnId(
                0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"),
                this.props.searchKey);
        }
        else
        {
            (this.getAPIModel() as SearchListAPIModel).loadMore(0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), this.props.searchKey);
        }
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SearchListViewImpl(this.featuredCategoryListViewModel,
             this.searchListAtistToneViewModelImpl, applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SearchListCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new SearchListAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: SearchListComponentProps)
    {
        this.featuredCategoryListViewModel.getListOfDatas().length = 0;
        this.searchListAtistToneViewModelImpl.getListOfDatas().length = 0;
        this.isOnLoadMore = false;
        this.setState({isDataNotLoaded: false, isEmpty: true});
        (this.getView() as SearchListViewImpl).showLoader(); 
        if(nextProps.type === this.props.context.getResources().getString(Strings.code))
        {
            (this.getAPIModel() as SearchListAPIModel).getSearchToneBasedOnId(
                0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"),
                nextProps.searchKey);
        }
        else
        {
            (this.getAPIModel() as SearchListAPIModel).loadMore(0, 
                +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), nextProps.searchKey);
        }
    }

    onSearchClicked(searchKey:string, type: string):void
    {
        searchKey = searchKey.trim();
        this.props.routeNextFeature(RoutingFeatures.SEARCH_LIST + "?searchkey=" + searchKey + "&type=" + type, false);
    }

    onLoadMore(startIndex: number, offset: number): void 
    {
        this.isOnLoadMore = true;
        // this.featuredCategoryListViewModel.getListOfDatas().length = 0;
        // this.searchListAtistToneViewModelImpl.getListOfDatas().length = 0;
        // this.forceUpdateComponent();
        (this.getView() as SearchListViewImpl).showLoader(); 
        if(this.props.type === this.props.context.getResources().getString(Strings.code))
        {
            (this.getAPIModel() as SearchListAPIModel).getSearchToneBasedOnId(startIndex, offset, this.props.searchKey);
        }
        else
        {
            (this.getAPIModel() as SearchListAPIModel).loadMore(startIndex,offset, this.props.searchKey);
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as SearchListViewImpl).dismissLoader(); 
        this.featuredCategoryListViewModel.getListOfDatas().length = 0;
        this.searchListAtistToneViewModelImpl.getListOfDatas().length = 0;
       
        if(feature === APIFeatures.SPECIFIC_SEARCH_TONE)
        {
            if(this.props.type === this.props.context.getResources().getString(Strings.song))
            {
                (this.featuredCategoryListViewModel.setListDatas((data as SpecificSearchToneDto).getToneList()));
                !this.isOnLoadMore ? this.featuredCategoryListViewModel.resetPaginationState() : (this.getView() as SearchListViewImpl).updatePaginationCount();
                this.setState({isEmpty: false, isDataNotLoaded: this.featuredCategoryListViewModel.getListOfDatas().length > 0 ? false :  true});
            }
            else if(this.props.type === this.props.context.getResources().getString(Strings.singer))
            {
                (this.searchListAtistToneViewModelImpl.setListDatas((data as SpecificSearchToneDto).getCountList().getArtistDetailList()));
                !this.isOnLoadMore ? this.featuredCategoryListViewModel.resetPaginationState() :(this.getView() as SearchListViewImpl).updatePaginationCount();
                this.setState({isEmpty: false, isDataNotLoaded: this.searchListAtistToneViewModelImpl.getListOfDatas().length > 0 ? false :  true});
            }
        }
        else if(feature === APIFeatures.SEARCH_TONE)
        {
            this.featuredCategoryListViewModel.setListDatas((data as ToneDto[]));
            !this.isOnLoadMore ? this.featuredCategoryListViewModel.resetPaginationState() : (this.getView() as SearchListViewImpl).updatePaginationCount();
            this.setState({isEmpty: false, isDataNotLoaded: this.featuredCategoryListViewModel.getListOfDatas().length > 0 ? false :  true});
        }

        window.scrollTo(0,0);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as SearchListViewImpl).dismissLoader(); 
        
        if(!this.isOnLoadMore)
        {
            this.featuredCategoryListViewModel.getListOfDatas().length = 0;
            this.setState({isEmpty: false, isDataNotLoaded: true});
        }
        //   (this.getView() as SearchListViewImpl).showPopup(this.getContext().getResources().getString(Strings.search),description,AlertType.ERROR);

        window.scrollTo(0,0);
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/searchlistcomponent.tsx